export default {
  text: 'Система управления сайтом и модуль библиотеки разработаны ООО БИМ при поддержке Фонда Сколково'
}
